<template>
  <div
    v-show="showWinner && showCarousel && !loading"
    class="leaderboard-winner vertical layout center center-justified animate__bounceIn animate__animated"
  >
    <div
      :class="{'white': $store.state.slideActive.textColour == '#ffffff'}"
      v-if="rankingList && rankingList[0]"
    >
      <div v-if="countWinner == 1" class="winner-list-top mb-4">
        <div class="box-winer winner-team" v-if="isShowingTeamList">
          <div class="winner-name">
            <span>{{ rankingList[0].name | profanity }}</span>
          </div>
          <div class="team-member" :class="fontSizeMemberWinner">
            <span
              v-for="(member, indexMember) in rankingList[0]?.members"
              v-show="indexMember < 10"
              :key="indexMember"
              class="mr-3"
            >{{ member.audienceEmoji }} {{ member.audienceName | profanity }}</span>
            <span
              v-if="rankingList[0]?.members?.length - 10 > 0"
            >+ {{ rankingList[0]?.members?.length - 10 }}</span>
          </div>
        </div>
        <div class="box-winer winner-individual" v-else>
          <div class="winner-name">
            <span class="winner-emoji">
              {{ rankingList[0]?.audienceEmoji }}
            </span>
            <span
              v-if="canFilterProfanity(rankingList[0])"
            >{{ rankingList[0].audienceName | profanity }}
            </span>
            <span v-else>
              {{ rankingList[0]?.isCensorName ?
                rankingList[0]?.censorName : rankingList[0]?.audienceName }}
            </span>
          </div>
        </div>
      </div>

      <div class="winner-point mb-4">
        {{ rankingList[0].totalPoint | formatTotalPoint }}
        <span
          class="short-cut-text"
        >{{ $t("points") }}</span>
      </div>
    </div>
    <div v-show="topWinnerStr && countWinner > 1" class="winner-list-top mb-4">
      <div class="text-center winner-title" v-html="$t('weHaveWinners', {msg: countWinner})" />
      <div class="marquee">
        <div class="marquee--text" :style="{'animation': timeRunbanner}">
          {{ $t("congratulationsTo") }} {{ topWinnerStr | profanity }}!
        </div>
      </div>
    </div>
    <div class="instruction text-base">
      <span class="mr-2 font-normal">{{ $t("Full Leaderboard") }}</span>
      <aha-shortcut-key keyName="W" class="inline" />
    </div>
  </div>
</template>

<script>
import LeaderboardMixin from '@/components/presentations/contents/LeaderboardMixin.vue'

export default {
  mixins: [LeaderboardMixin],
  props: {
    rankingList: {
      type: Array,
      default: () => [],
    },
    countWinner: {
      type: Number,
      default: null,
    },
    topWinnerStr: {
      type: String,
      default: null,
    },
    showCarousel: {
      type: Boolean,
      default: false,
    },
    showWinner: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isShowingTeamList: {
      type: Boolean,
      default: false,
    },
    timeRunbanner: {
      type: String,
      default: null,
    },
    fontSizeMemberWinner: {
      type: [String, Object],
      default: null,
    },
  },
}
</script>

<style lang="scss" scoped>
$leaderboard-max-height: 300px;
.leaderboard-winner {
  position: absolute;
  top: 22%;
  left: 0;
  width: 100%;
  text-align: center;
  height: calc($leaderboard-max-height + 15px);
  font-size: 42px;
  font-weight: bold;
  padding: 30px 0 30px;
  line-height: 1.2;
  z-index: 10;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.7);
  .light & {
    background-color: rgba(240, 240, 240, 0.8);
    color: #333;

  }

  .team-member {
    font-size: 33px;
    margin: 10px;
    font-weight: normal;

    &.size-1 {
      font-size: 28px;
    }
    &.size-2 {
      font-size: 26px;
    }
    &.size-3 {
      font-size: 24px;
    }
    &.size-4 {
      font-size: 22px;
    }
    &.size-5 {
      font-size: 20px;
    }
    &.size-6 {
      font-size: 16px;
    }
  }
  .winner-list-top {
    font-size: 60px;
    position: relative;
    z-index: 99999;
    width: 100%;

    .winner-name {
      font-size: 60px;
    }
  }

  .winner-point {
    font-size: 60px;
  }
  .winner-emoji {
    font-weight: initial;
  }

  .marquee {
    width: 100%;
    margin: 0 auto;
    overflow: hidden;
    white-space: nowrap;
    box-sizing: border-box;
  }

  .marquee--text {
    display: inline-block;
    padding-left: 100%;
    text-indent: 0;
  }

  .marquee--text:hover {
    animation-play-state: paused;
  }
}

</style>
